import { FC, ReactNode } from 'react'
import Checkbox from 'components/atoms/inputs/Checkbox'
import { useFormContext } from 'react-hook-form'
import styles from 'components/features/future/FutureLayerPast/PastCardCheckbox/PastCardCheckbox.styl'

type PastCardCheckboxProps = {
  name: string
  label: ReactNode
}
export const PastCardCheckbox: FC<PastCardCheckboxProps> = (props) => {
  const { name, label } = props

  const { register } = useFormContext()

  return (
    <div className={ styles.pastCardCheckbox }>
      <Checkbox
        label={ label }
        name={ name }
        register={ register }
      />
    </div>
  )
}
